<template>
    <div class="container">
        <v-card>
            <v-row>
                <v-col cols="11">
                    <v-card-title class="titulopagina">LISTADO DE EQUIPOS</v-card-title> 
                </v-col>
                <v-col cols="1">
                    <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                        <v-icon color="blue" large>help</v-icon>
                    </v-alert>
                </v-col>
            </v-row>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <div class="row">
            <div class="col-md-4" v-for="(items, punto_medicion_id) in list">
                <table class="table-dashboard border">
                    <thead>
                    <th class="cabecera elevation-1 ">
                        {{ getGroupedByName(punto_medicion_id) }}
                    </th>
                    <th class="cabecera border">
                        Estado
                    </th>
                    <th class="cabecera border">
                        Fecha
                    </th>
                    </thead>
                    <tbody>
                    <tr v-for="item in items" class="text-center">
                        <td class="sin-padding">
                            {{ item.nombre_equipo }}
                        </td>
                        <td class="sin-padding">
                            <div class="row col-12 pa-0 sin-padding">
                                <div class="col-8 pa-8 sin-padding">
                                    {{ getEstadoLabel(item.estado) }}
                                </div>
                                <div class="col-4 sin-padding">
                                    <v-switch v-model="item.estado" @change="openCreateEventModal(item)" class="sin-margin"></v-switch>
                                </div>
                            </div>
                        </td>
                        <td class="sin-padding">
                            {{ getFormattedDate(item.estado_fecha) }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <v-dialog v-model="showEventModal" persistent max-width="600px">
            <v-card>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col>
                                <v-textarea
                                    solo
                                    name="input-7-4"
                                    label="Escriba un comentario..."
                                    v-model="equipo_evento.observaciones"
                                ></v-textarea>
                                Fecha / Hora <date-picker type="datetime" @change="validateDate" class="dtpicker" :clearable="false" :confirme="true"
                                                          v-model="equipo_evento.fecha" format="DD-MM-YYYY HH:mm"
                                                          valueType="YYYY-MM-DD HH:mm"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-alert dense text type="info" v-if="!canSave">
                                La fecha seleccionada debe ser menor a la fecha actual <strong>!</strong>
                            </v-alert>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" dark @click="closeCreateEventModal">Cancelar</v-btn>
                    <v-btn color="green darken-1" dark @click="changeSatatus" :class="{'is-disable': !canSave}">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
import Data_Table_Filtro from "@/components/shared/Data_Table_Filtro";
import get from 'lodash/get';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data() {
        return {
            list: [],
            puntosMedicion: [],
            equipo_evento: [],
            showEventModal: false,
            canSave: false,
        }
    },

    mounted() {
        this.cargarListado()
        this.cargarPuntosMedicion()
    },

    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Listado de Equipos`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra e indica si los equipos dentro de la planta se encuentran en estado activo o inactivo (fuera de servicio), añadiendo un comentario y una fecha/hora al momento de realizar algún cambio en algún equipo`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },

        validateDate(value) {
            if (value && value <= this.moment(Date.now()).format('YYYY-MM-DD hh:mm')) {
                this.canSave = true

                return
            }

            this.canSave = false
        },

        getFormattedDate(date) {
            return date !== null ? this.moment(date).format('DD/MM/YYYY hh:mm') : '-'
        },

        openCreateEventModal(item) {
            this.equipo_evento = item
            this.showEventModal = true
        },

        closeCreateEventModal() {
            this.showEventModal = false
            this.equipo_evento = []
            this.cargarListado()
        },

        async changeSatatus() {
            this.mostrarLoading({titulo: 'Actualizando Datos...', color: 'green'})
            await this.axios.post(`${this.base_url}equipo_eventos`, this.equipo_evento, this.headers).then(() => {
                this.closeCreateEventModal()
                this.cargarListado()
                this.ocultarLoading();
            }).catch((error) => {
                console.log(error);
                this.ocultarLoading();
            });
        },

        getEstadoLabel(status) {
            return status === 1 ? 'En Servicio' : 'Fuera Servicio'
        },

        getGroupedByName(id) {
            let result = this.puntosMedicion.filter(item => item.id === parseInt(id))

            return get(result[0], 'nombre_punto')
        },

        async cargarListado() {
            this.mostrarLoading({titulo: 'Cargando listado de equipos...', color: 'green'})

            let url = `${this.base_url}equipo_planta/list`;
            await this.axios.get(url, this.headers).then((response) => {
                this.list = response.data.data
                this.canSave = false
                this.ocultarLoading();
            }).catch((error) => {
                console.log('error', error);
                this.ocultarLoading();
            });
        },

        async cargarPuntosMedicion() {
            let url = `${this.base_url}punto_medicion`;
            await this.axios.get(url, this.headers).then((response) => {
                this.puntosMedicion = response.data.data;
            }).catch((error) => {
                console.log('error', error);
            });
        },
        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },

    computed: {
        ...mapState(['base_url', 'headers']),
    },

    components: {
        Data_Table_Filtro,
        'modal': Modal,
        'modal-ayuda':ModalAyudas,
        'data-table': Data_Table,
        DatePicker
    }
}
</script>
<style scoped>
.border {
    border: 1px solid #3f51b5;
}

.table-dashboard {
    border-collapse: collapse;
    width: 100%;
}

.table-dashboard th, td, tr {
    border: 1px solid #00bfa5;
}

.sin-margin{
    margin: 0px 0px 0px 0px !important;
}


.is-disable {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.5;
}
</style>
